import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {AppBar, Tabs, Tab} from '@material-ui/core';
import MDEditor from '@uiw/react-md-editor';

function TabPanel(props) {
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    'aria-controls': `nav-tabpanel-${index}`,
  };
}

function LinkTab(props) {
  return (
    <Tab
      component="a"
      onClick={event => {
        event.preventDefault();
      }}
      {...props}
    />
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#3D3D3D',
  },
  appBar: {
    backgroundColor: 'black',
  },
  content: {
    color: 'white',
    padding: '1rem',
  },
}));

export default function Pages({pages}) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      {pages.length > 0 && (
        <>
          <AppBar position="static" className={classes.appBar}>
            <Tabs
              variant="scrollable"
              scrollButtons="auto"
              value={value}
              onChange={handleChange}
              aria-label="nav tabs example"
              TabIndicatorProps={{
                style: {
                  backgroundColor: 'white',
                },
              }}
            >
              {pages.map((x, index) => {
                return <LinkTab key={index} label={x.title} href="/drafts" {...a11yProps(index)} />;
              })}
            </Tabs>
          </AppBar>
          {pages.map((x, index) => {
            return (
              <TabPanel key={index} value={value} index={index} className={classes.content}>
                <MDEditor.Markdown source={x.content} />
              </TabPanel>
            );
          })}
        </>
      )}
    </div>
  );
}
